export enum RbacQueryKeys {
  RBAC_ME = 'rbac-me',
}
